import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fileUrl = (path) =>
  path ? `${API}/files/${path}?auth=${encodeURIComponent(localStorage.getItem("token") || "")}` : "";

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return res.data;
}

export function scadenzaInfo(scad) {
  if (!scad) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(scad + "T00:00:00");
  const days = Math.round((d - today) / 86400000);
  if (days < 0) return { days, cls: "bg-rose-50 text-rose-700 border-rose-200", label: "Scaduto" };
  if (days <= 30) return { days, cls: "bg-amber-50 text-amber-700 border-amber-200", label: `Scade tra ${days}g` };
  return { days, cls: "bg-emerald-50 text-emerald-700 border-emerald-200", label: "Valido" };
}

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const fmtEur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d)) return s;
  return d.toLocaleDateString("it-IT");
};

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadFile(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(new Blob([res.data]));
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export async function downloadScheda(corsista, azienda, corso, aziendaId) {
  const az = azienda || {};
  const corsiArr = Array.isArray(corso) ? corso.filter(Boolean) : (corso ? [corso] : []);
  const payload = {
    azienda: {
      nome: az.nome || "", indirizzo: az.indirizzo || "", citta: az.citta || "", cap: az.cap || "",
      telefono: az.telefono || "", pec: az.pec || "", partita_iva: az.partita_iva || "",
      codice_fiscale: az.codice_fiscale || "", codice_destinatario: az.codice_destinatario || "",
      email: az.email || "", codice_ateco: az.codice_ateco || "",
    },
    corsista: {
      nome: corsista.nome || "", cognome: corsista.cognome || "", codice_fiscale: corsista.codice_fiscale || "",
      data_nascita: corsista.data_nascita || "", luogo_nascita: corsista.luogo_nascita || "",
      provincia_nascita: corsista.provincia_nascita || "", indirizzo: corsista.indirizzo || "",
      citta: corsista.citta || "", cap: corsista.cap || "", telefono: corsista.telefono || "",
      cellulare: corsista.cellulare || "", email: corsista.email || "", mansione: corsista.mansione || "",
    },
    corso: corsiArr[0] || "",
    corsi: corsiArr,
    azienda_id: aziendaId || az.id || "",
  };
  const res = await api.post("/scheda-iscrizione", payload, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `Scheda_iscrizione_${corsista.cognome || ""}_${corsista.nome || ""}.pdf`.replace(/\s+/g, "_");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
